import type { CSSProperties } from 'react'

/**
 * Hide an element visually while keeping it rendered, focusable, and
 * programmatically clickable.
 *
 * Use this for `<input type="file">` elements that are opened via a JS
 * `inputRef.current.click()` or an associated `<label>`. Safari (Mac/iOS)
 * silently no-ops `.click()` on an input hidden with `display: none` or
 * `visibility: hidden` — the file picker never opens. A visually-hidden but
 * *rendered* input does not hit that quirk. Mirrors the pattern already used
 * by DocumentChips.
 */
export const VISUALLY_HIDDEN: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
}
